import { get } from 'lodash';
import { firstValueFrom } from 'rxjs';

import { preprocessValidationConfigs } from './preprocess-validation-configs';
import { jsonataEval } from '../../jsonata/functions/jsonata-eval';
import { IProcessedValidationConfig } from '../types/processed-validation-config.interface';
import { IValidationConfig } from '../types/validation-config.interface';
import { IValidationResult } from '../types/validation-result.interface';
import { ValidatorFunction } from '../types/validator-function.type';
import { validators } from '../validators/validators';

export async function evaluateValidationConfigs(
  aggregateValue: any,
  validationConfigs: IValidationConfig[] | undefined,
  processAll: boolean
): Promise<IValidationResult[]> {
  const errs: IValidationResult[] = [];

  if (!aggregateValue || !validationConfigs?.length) {
    return errs;
  }

  const validationMap: Map<string, IProcessedValidationConfig> = await firstValueFrom(
    preprocessValidationConfigs(validationConfigs)
  );

  for (const validationConfig of validationMap.values()) {
    if (!errs.length || processAll) {
      for (const [validatorKey, { args, expression }] of validationConfig.validators.entries()) {
        // eslint-disable-next-line no-await-in-loop
        if (((!errs.length || processAll) && !expression) || (await jsonataEval(expression, aggregateValue)) === true) {
          let validationErrors = (validators.get(validatorKey) as ValidatorFunction)(
            get(aggregateValue, validationConfig.targetPath),
            args,
            aggregateValue
          );

          if (validationErrors instanceof Promise) {
            // eslint-disable-next-line no-await-in-loop
            validationErrors = await validationErrors;
          }

          if (validationErrors) {
            errs.push({ path: validationConfig.targetPath, errors: validationErrors });
          }
        }
      }
    }
  }

  return errs;
}
